import { render, staticRenderFns } from "./SingleTaskCard.vue?vue&type=template&id=74242d68&scoped=true&"
import script from "./SingleTaskCard.vue?vue&type=script&lang=js&"
export * from "./SingleTaskCard.vue?vue&type=script&lang=js&"
import style0 from "./SingleTaskCard.vue?vue&type=style&index=0&id=74242d68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74242d68",
  null
  
)

export default component.exports